<template>
  <form @submit.prevent="onSubmit">
    <div class="row">
      <div class="col-12 col-sm-6">
        <div class="form-group">
          <label :for="createId('brand')">
            Márka
          </label>
          <select
            :id="createId('brand')"
            class="form-control form-control-sm"
            :value="filters.make"
            @input="onMakeInput($event.target.value)"
          >
            <option></option>
            <option
              v-for="make in makes"
              :key="make.slug"
              :value="make.slug"
            >
              {{ make.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <div class="form-group">
          <label :for="createId('model')">
            Modell
          </label>
          <select
            :id="createId('model')"
            class="form-control form-control-sm"
            :disabled="models.length === 0"
            :value="filters.model"
            @input="updateFilter('model', $event.target.value)"
          >
            <option></option>
            <option
              v-for="model in models"
              :key="model.slug"
              :value="model.slug"
            >
              {{ model.MODNameGrp1 }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-6">
        <div class="form-group">
          <label :for="createId('body_type')">
            Karosszéria típus
          </label>
          <select
            :id="createId('body_type')"
            class="form-control form-control-sm"
            :value="filters.body_type"
            @input="updateFilter('body_type', $event.target.value)"
          >
            <option></option>
            <option
              v-for="bodyType in bodyTypes"
              :key="bodyType.slug"
              :value="bodyType.slug"
            >
              {{ bodyType.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <div class="form-group">
          <label :for="createId('gear_shift')">Váltó</label>
          <select
            :id="createId('gear_shift')"
            class="form-control form-control-sm"
            :value="filters.gear_shift"
            @input="updateFilter('gear_shift', $event.target.value)"
          >
            <option></option>
            <option
                v-for="gearShift in gearShifts"
                :key="gearShift.slug"
                :value="gearShift.slug"
                v-html="gearShift.name"
            ></option>
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-6">
        <div class="form-group">
          <label :for="createId('cap_tech')">Hengerűrtartalom</label>
          <select
            :id="createId('cap_tech')"
            class="form-control form-control-sm"
            :value="filters.cap_tech"
            @input="updateFilter('cap_tech', $event.target.value)"
          >
            <option></option>
            <option
              v-for="capTech in capTechs"
              :key="'cap_tech_' + capTech.slug"
              :value="capTech.slug"
              v-html="capTech.name"
            ></option>
          </select>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <div class="form-group">
          <label :for="createId('fuel_type')">Üzemanyag</label>
          <select
            :id="createId('fuel_type')"
            class="form-control form-control-sm"
            :value="filters.fuel_type"
            @input="updateFilter('fuel_type', $event.target.value)"
          >
            <option></option>
            <option
              v-for="fuelType in fuelTypes"
              :key="'fuel_type_' + fuelType.slug"
              :value="fuelType.slug"
            >
              {{ fuelType.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-6">
        <div class="form-group">
          <label :for="createId('ph')">Teljesítmény</label>
          <select
            :id="createId('ph')"
            class="form-control form-control-sm"
            :value="filters.ph"
            @input="updateFilter('ph', $event.target.value)"
          >
            <option></option>
            <option
              v-for="ph in phs"
              :key="'ph' + ph.slug"
              :value="ph.slug"
            >
              {{ ph.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <div class="form-group">
          <label :for="createId('accel')">Gyorsulás</label>
          <select
            :id="createId('accel')"
            class="form-control form-control-sm"
            :value="filters.accel"
            @input="updateFilter('accel', $event.target.value)"
          >
            <option></option>
            <option
              v-for="accel in accels"
              :key="'accel_' + accel.slug"
              :value="accel.slug"
            >
              {{ accel.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-sm-6">
        <div class="form-group">
          <label :for="createId('trunk_cap')">Csomagtér</label>
          <select
            :id="createId('trunk_cap')"
            class="form-control form-control-sm"
            :value="filters.trunk_cap"
            @input="updateFilter('trunk_cap', $event.target.value)"
          >
            <option></option>
            <option
              v-for="trunkCap in trunkCaps"
              :key="'trunkCap' + trunkCap.slug"
              :value="trunkCap.slug"
            >
              {{ trunkCap.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <div class="form-group">
          <label :for="createId('typseat')">Ülések száma</label>
          <select
              :id="createId('typseat')"
              class="form-control form-control-sm"
              :value="filters.typseat"
              @input="updateFilter('typseat', $event.target.value)"
          >
            <option></option>
            <option
                v-for="typseat in typseats"
                :key="typseat"
                :value="typseat"
            >
              {{ typseat }} fő
            </option>
          </select>
        </div>
      </div>


      <div class="col-12 col-sm-12">
        <label>Bérleti díj</label>

        <div class="bootstrap-slider-container">
          <b-form-slider
              v-model="rangeValue"
              range
              :step="1000"
              :min="min_price"
              :max="max_price"
              @slide-stop="updateMinMax()">
          </b-form-slider>
        </div>
      </div>

      <div class="col-12 col-sm-6">
        <label :for="createId('min_price')">Minimum bérleti díj</label>

        <input
            :id="createId('min_price')"
            :value="rangeValue[0]+' Ft'"
            type="text"
            disabled
            class="form-control form-control-sm"
        >
      </div>

      <div class="col-12 col-sm-6">
        <label :for="createId('max_price')">Maximum bérleti díj</label>
        <input
            :id="createId('max_price')"
            :value="rangeValue[1] +' Ft'"
            type="text"
            disabled
            class="form-control form-control-sm"
        >

      </div>
    </div>
    <button
      type="submit"
      class="btn btn-block btn-primary mt-3"
    >
      Összetett keresés
    </button>
  </form>
</template>

<script>
  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';
  import { namespace } from 'vuex-class';

  const searchModule = namespace('search');

  function paramsToObject(entries) {
    let result = {};
    for (let entry of entries) { // each 'entry' is a [key, value] tupple
      const [key, value] = entry;
      result[key] = value;
    }
    return result;
  }

  @Component
  export default class SearchForm extends Vue {
    @searchModule.State('makes') makes;
    @searchModule.State('models') models;
    @searchModule.State('bodyTypes') bodyTypes;
    @searchModule.State('gearShifts') gearShifts;
    @searchModule.State('capTechs') capTechs;
    @searchModule.State('fuelTypes') fuelTypes;
    @searchModule.State('phs') phs;
    @searchModule.State('co2emits') co2emits;
    @searchModule.State('typseats') typseats;
    @searchModule.State('trunkCaps') trunkCaps;
    @searchModule.State('accels') accels;
    @searchModule.State('filters') filters;
    @searchModule.Mutation('setFilters') setFilters;
    @searchModule.Action('initializeState') initializeState;
    @searchModule.Action('fetchModels') fetchModels;
    @searchModule.Action('fetchBodyTypes') fetchBodyTypes;
    @searchModule.Action('fetchFuelTypes') fetchFuelTypes;
    @searchModule.Action('fetchGearShifts') fetchGearShifts;
    @searchModule.Action('fetchCapTechs') fetchCapTechs;
    @searchModule.Action('fetchPhs') fetchPhs;
    @searchModule.Action('fetchAccels') fetchAccels;
    @searchModule.Action('fetchCo2Emits') fetchCo2Emits;
    @searchModule.Action('fetchTypseats') fetchTypseats;
    @searchModule.Action('fetchTrunkCaps') fetchTrunkCaps;

    @Prop(String) url;
    @Prop(String) id;
    @Prop(Number) max_price;
    @Prop(Boolean) prefetch;

    rangeValue = null;
    min_price =  60000;

    created() {

      this.rangeValue = [this.min_price, this.max_price];

      if (location.search) {
        const params = new URLSearchParams(location.search);
        const filters = paramsToObject(params.entries());

        this.rangeValue = [filters.min_price ? parseInt(filters.min_price) : this.min_price, filters.max_price ? parseInt(filters.max_price) : this.max_price];

        this.setFilters({
          ...filters,
          commercialVehicle: this.filters.commercialVehicle,
          min_price: this.rangeValue[0],
          max_price: this.rangeValue[1]
        });
      }

      this.initializeState();

    }

    createId(id) {
      return `${this.id}_${id}`;
    }

    onSubmit() {
      const url = new URL(this.url);
      for (let key in this.filters) {
        if (key !== 'commercialVehicle') {
          url.searchParams.append(key, this.filters[key]);
        }
      }

      url.searchParams.set('page', "1");

      location.href = url.href
    }

    onMakeInput(value) {
      this.updateFilter('make', value);
      this.updateFilter('model', '');

      this.fetchModels();
    }

    updateMinMax() {

      const updatedFilters = {...this.filters};

      updatedFilters['min_price'] = this.rangeValue[0];
      updatedFilters['max_price'] = this.rangeValue[1];

      this.setFilters(updatedFilters);
    }

    updateFilter(key, value) {
      const updatedFilters = {...this.filters};
      updatedFilters[key] = value;

      this.setFilters(updatedFilters);
      this.fetchBodyTypes();
      this.fetchFuelTypes();
      this.fetchGearShifts();
      this.fetchCapTechs();
      this.fetchPhs();
      this.fetchAccels();
      this.fetchCo2Emits();
      this.fetchTypseats();
      this.fetchTrunkCaps();
    }
  }
</script>
